import { NgModule } from '@angular/core';
import { DraggableDirective } from 'src/app/_directives/draggable.directive';
import {DayPilot} from 'daypilot-pro-angular';

@NgModule({
  declarations: [DraggableDirective],
  exports: [DraggableDirective], // Exportiere die Direktive, damit sie in anderen Modulen verwendet werden kann
})
export class SharedModule { }